import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Error from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';

import { TOMATO } from 'bento-ordering/base/constants/colors';
import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

const useTypographyStyles = makeStyles(theme => ({
  root: {
    color: TOMATO,
    fontSize: '14px',
    position: 'relative',
    top: '-2px'
  }
}));

const useIconStyles = makeStyles({
  root: {
    fill: TOMATO,
    fontSize: '16px'
  }
});

const OutlinedBoxError = ({ children }) => {
  const typographyClasses = useTypographyStyles();
  const iconClasses = useIconStyles();
  return (
    <Box
      padding="10px"
      border={`2px solid ${TOMATO}`}
      borderRadius={4}
      display="flex"
      classes={typographyClasses}
    >
      <Box width="20px" mr={1}>
        <Error classes={iconClasses} />
      </Box>
      <Box flex="2">
        <Typography classes={typographyClasses}>{children}</Typography>
      </Box>
    </Box>
  );
};

OutlinedBoxError.propTypes = {
  children: CHILDREN_PROPTYPES.isRequired
};
export default OutlinedBoxError;
